// extracted by mini-css-extract-plugin
module.exports = {"blockTopImg":"blockTopImg-module--blockTopImg--2d-qS","blockTopImg__img":"blockTopImg-module--blockTopImg__img--2raqk"};